import makeQueryKey from "../../../utils/make-query-key";
var getProductFeedThreadsQueryKey = function getProductFeedThreadsQueryKey(_ref) {
  var productId = _ref.productId,
    styleColor = _ref.styleColor,
    fetchVasContent = _ref.fetchVasContent;
  return makeQueryKey(['product_feed/threads/v2', {
    productId: productId,
    styleColor: styleColor,
    fetchVasContent: fetchVasContent
  }]);
};
export default getProductFeedThreadsQueryKey;